<template>
  <div class="searchExams" ref="searchExams">
    <div class="searchExams__list">
      <p class="searchExams__title">Carrinho</p>

      <p class="searchExams__list--header" v-if="selectedExams.length">
        {{ selectedExams.length }} exame(s) adicionado(s)
      </p>
      <div
        v-if="selectedExams.length"
        @click="openDrawerToRemoveAllExamsSelected"
        class="searchExams__result--href"
      >
        Limpar
        <TrashSvg class="trash-svg" alt="Remover exame" />
      </div>
      <div v-if="!loader">
        <div v-if="selectedExams.length === 0">
          <EmptyCartPartial />
        </div>

        <div v-else>
          <p class="searchExams__result--text">
            Após confirmar a seleção, só será possível alterar os serviços no guichê.
          </p>
          <div v-for="(exam, idx) in selectedExams" :key="exam.id" class="searchExams__card">
            <ExamListCardPartial
              :exam="exam"
              :idx="idx"
              @addExamClick="addExam"
              @removeExamClick="openDrawerToRemove"
              :hideSynonymy="true"
            />
          </div>
        </div>
      </div>
    </div>

    <DrawerBottom
      :open="openDrawer"
      @toggle="openDrawer = !openDrawer"
      @close="closeDrawer"
      v-if="openDrawer"
    >
      <template #content>
        <div class="drawer-content" v-if="shouldRemoveExam">
          <h3>Deseja excluir exame: {{ selectedExamToRemove.name }}</h3>
          <div class="drawer-buttons">
            <button @click="removeExam({}, selectedExamToRemove)">Excluir</button>
            <button @click="closeDrawer">Voltar</button>
          </div>
        </div>

        <div class="drawer-content" v-else-if="shouldRemoveAllExams">
          <h3>Deseja excluir todos os exames selecionados?</h3>
          <div class="drawer-buttons">
            <button @click="clearAllExamsSelected">Excluir</button>
            <button @click="closeDrawer">Voltar</button>
          </div>
        </div>

        <div class="drawer-content" v-else>
          <h3>Todos serviços foram selecionados?</h3>
          <p>Após confirmar a seleção, só será possível alterar os serviços no guichê.</p>
          <div class="drawer-buttons">
            <button @click="goToQuestionsStep">Confirmar seleção</button>
            <button @click="closeDrawer">Alterar serviços</button>
          </div>
        </div>
      </template>
    </DrawerBottom>
    <div class="searchExams__footer" v-if="selectedExams.length">
      <div class="totalAmount">
        <span class="totalAmount__label">Valor total</span>
        <span class="totalAmount__value">{{ formatCurrency(totalPrice) }}</span>
      </div>
      <VButton
        class="searchExams__footer--button"
        text="Continuar"
        variant="primary"
        @click.native="showDrawer"
      />
      <VButton
        text="Adicionar outros exames"
        variant="secondary"
        @click.native="goToSearchExamPage"
      />
    </div>

    <div class="searchExams__footer" v-else>
      <VButton
        class="searchExams__footer--button"
        text="Adicionar exames"
        variant="primary"
        @click.native="goToSearchExamPage"
      />
      <VButton text="Continuar sem exames" variant="secondary" @click.native="goToConclusion" />
    </div>
  </div>
</template>

<script>
import EmptyCartPartial from './partials/emptyCart.partial.vue';
import ExamListCardPartial from './partials/examListCard.partial.vue';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import { dataLayersMixin } from '@/utils/mixins';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'search-exams',
  components: {
    ExamListCardPartial,
    DrawerBottom,
    EmptyCartPartial,
  },
  mixins: [dataLayersMixin],
  data() {
    return {
      loader: false,
      showSelectedExams: false,
      examsListTitle: 'Adicione seus exames',
      queryExams: '',
      searchResult: [],
      selectedExams: [],
      debounce: false,
      showNotFoundExams: false,
      openDrawer: false,
      highlightedExams: [],
      shouldRemoveExam: false,
      shouldRemoveAllExams: false,
      selectedExamToRemove: [],
    };
  },
  created() {
    if (this.currentAdmission.medicalOrders) {
      const { exams = [] } = this.currentAdmission.medicalOrders[0];
      if (exams.length) {
        return this.goNextStep('questions_step');
      }
    }
    if (this.selectedExamsState.length) {
      this.selectedExams = this.selectedExamsState;
    }
  },
  mounted() {
    this.mostCommonPagesAnalytics({
      step: 'seleção_de_serviços',
      screen: 'carrinho',
      items: this.selectedExams.map(({ id, name, price }) => ({
        id,
        name,
        price,
        quantity: 1,
      })),

      complementaryObject: {
        payment: {
          type: 'particular',
        },
      },
    });
  },
  computed: {
    ...mapState({
      biologicalSex: ({ mdm }) => mdm.data.biologicalSex,
      selectedExamsState: ({ searchExams }) => searchExams.data.manuallySelectedExams,
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit.idUnidade,
      selectedBrandId: ({ brandUnit }) => brandUnit.data.currentBrand.brandId,
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
    }),
    totalPrice() {
      return this.selectedExams.reduce((p, c) => p + c.price, 0);
    },
  },
  methods: {
    ...mapActions([
      'createMedicalOrders',
      'global/updateFlowSteps',
      'setAdmissionNotElegible',
      'getMedicalOrdersByAdmissionId',
    ]),
    ...mapMutations({
      setSelectedExams: 'SET_SELECTED_EXAMS',
      clearQuestionnarie: 'SET_RESET_QUESTIONNAIRE',
    }),
    openDrawerToRemove(_, exam, idx) {
      this.$refs.searchExams.scrollIntoView({ block: 'start', scrollBehavior: 'smooth' });
      document.body.style.overflow = 'hidden';
      this.shouldRemoveExam = true;
      this.openDrawer = true;
      this.selectedExamToRemove = exam;
    },
    clearAllExamsSelected() {
      this.closeDrawer();
      this.shouldRemoveAllExams = false;
      this.selectedExams = [];
      this.setSelectedExams([]);
    },
    openDrawerToRemoveAllExamsSelected() {
      this.showDrawer();
      this.shouldRemoveAllExams = true;
    },
    async goToConclusion() {
      await this.setAdmissionNotElegible();
      document.body.style.overflow = null;

      return this.$router.push({
        name: 'exams-skip',
        params: { previous_choice: 'Continuar sem exames' },
      });
    },
    showDrawer(modal) {
      this.openDrawer = true;
      this.$refs.searchExams.scrollIntoView({ block: 'start', scrollBehavior: 'smooth' });
      document.body.style.overflow = 'hidden';
      if (modal) {
        this.mostCommonPagesAnalytics({
          step: 'seleção_de_serviços',
          screen: 'modal_confirmação_serviços',
          items: this.selectedExams.map(({ id, name, price }) => ({
            id,
            name,
            price,
            quantity: 1,
          })),

          complementaryObject: {
            payment: {
              type: 'particular',
            },
          },
        });
      }
    },
    closeDrawer() {
      this.openDrawer = false;
      this.shouldRemoveExam = false;
      document.body.style.overflow = null;
    },
    async goToQuestionsStep() {
      document.body.style.overflow = null;
      const toast = document.getElementsByClassName('toasted');
      if (toast.length) {
        toast[0].style.display = 'none';
      }
      await this.createMedicalOrders();
      this['global/updateFlowSteps']([13, 2]);
      await this.getMedicalOrdersByAdmissionId();

      await this.goNextStep('questions_step');
    },
    goToSearchExamPage() {
      return this.$router.go(-1);
    },
    addExam(_, exam) {
      const toast = document.getElementsByClassName('toasted');
      if (toast.length) {
        toast[0].style.display = 'none';
      }

      const hasSelectedSameExam = this.selectedExams.find(
        (highlightedExam) => highlightedExam.id === exam.id,
      );
      const hasExamHighlighted = this.highlightedExams.find(
        (highlightedExam) => highlightedExam.id === exam.id,
      );
      const includedSearchExam = this.searchResult.find(
        (searchExamResult) => searchExamResult.id === exam.id,
      );

      if (hasSelectedSameExam) {
        return;
      }

      if (includedSearchExam) {
        const searchResultUpdated = this.searchResult.map((searchResultExam) => {
          if (searchResultExam.id === exam.id) {
            searchResultExam.added = true;
          }
          return searchResultExam;
        });
        this.searchResult = [...searchResultUpdated];
      }

      if (hasExamHighlighted) {
        const highlightedExamsUpdated = this.highlightedExams.map((highlightedExam) => {
          if (highlightedExam.id === exam.id) {
            highlightedExam.added = true;
          }
          return highlightedExam;
        });
        this.highlightedExams = [...highlightedExamsUpdated];
      }
      this.selectedExams = [...this.selectedExams, { ...exam, added: true }];
      this.setSelectedExams(this.selectedExams);
      this.examsListTitle = 'Adicione seus exames';
      this.clearQuestionnarie();
      this.$toasted.show('1 item adicionado', {
        position: 'bottom-center',
        duration: 5000,
        fullWidth: false,
        className: 'toast-action',
        action: [
          {
            text: 'Ver carrinho',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        ],
      });

      this.mostCommonPagesAnalytics({
        eventType: 'service_selection_add_to_cart',
        step: 'seleção_de_serviços',
        screen: 'busca',

        items: this.selectedExams.map(({ id, name, price }) => ({
          id,
          name,
          price,
        })),

        complementaryObject: {
          payment: {
            type: 'particular',
          },
        },
      });
    },
    removeExam(_, exam) {
      const toast = document.getElementsByClassName('toasted');
      if (toast.length) {
        toast[0].style.display = 'none';
      }
      this.closeDrawer();

      const oldSelectedExams = [...this.selectedExams];
      const oldHighlightedExams = JSON.stringify(this.highlightedExams);

      const newSelectedExams = this.selectedExams.filter(
        (selectedExam) => selectedExam.id !== exam.id,
      );

      const hasExamHighlighted = this.highlightedExams.find(
        (highlightedExam) => highlightedExam.id === exam.id,
      );

      if (hasExamHighlighted) {
        this.highlightedExams.forEach((highlightedExam) => {
          if (highlightedExam.id === exam.id) {
            highlightedExam.added = false;
          }
        });
      }
      this.selectedExams = newSelectedExams;
      this.setSelectedExams(newSelectedExams);
      this.clearQuestionnarie();
      this.$toasted.show('1 item excluído', {
        position: 'bottom-center',
        duration: 5000,
        fullWidth: false,
        className: 'toast-action',
        singleton: true,
        action: [
          {
            text: 'Desfazer',
            onClick: (e, toastObject) => {
              this.selectedExams = oldSelectedExams;
              this.setSelectedExams(oldSelectedExams);
              this.highlightedExams = JSON.parse(oldHighlightedExams);
              toastObject.goAway(0);
            },
          },
        ],
      });

      this.mostCommonPagesAnalytics({
        eventType: 'service_selection_remove_from_cart',
        step: 'seleção_de_serviços',
        screen: 'carrinho',

        items: [
          {
            id: exam.id,
            name: exam.name,
            price: exam.price,
            quantity: 1,
          },
        ],
        complementaryObject: {
          payment: {
            type: 'particular',
          },
        },
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
  },
};
</script>

<style lang="scss">
.searchExams {
  width: 100%;
  scrollbar-width: none;

  &__input {
    padding-bottom: 14px;
  }

  &__result {
    &--text {
      font-size: 14px;
      line-height: 170%;
      text-align: left;
      margin-top: 24px;
    }

    &--href {
      color: var(--color-interaction-accent-1);
      font-weight: var(--font-weight-bold);
      font-size: 14px;
      text-align: right;
      margin-top: -14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;

      * {
        fill: var(--color-interaction-accent-1);
      }
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__list {
    overflow: hidden;
    padding-bottom: 185px;
    padding-top: 80px;

    &--header {
      text-align: left;
      font-size: var(--font-size-2);
      line-height: 170%;
      color: #363636;
      padding-top: 16px;
    }

    &--header-bold {
      text-align: left;
      font-size: var(--font-size-2);
      line-height: 170%;
      color: #363636;
      padding-top: 16px;
      font-weight: var(--font-weight-bold);
    }

    &--cart {
      display: flex;
      position: relative;
      justify-content: space-between;
      align-items: center;
    }

    &--cart-amount {
      position: absolute;
      right: 0;
      font-size: var(--font-size-1);
      background-color: white;
      border-radius: 20px;
      border: 1.5px solid var(--color-interaction-accent-1);
      padding: 1px 4px;
      color: var(--color-interaction-accent-1);
      z-index: 1;
    }

    &--cart-icon {
      right: 24px;
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: inherit;
    margin: 0 auto;
    padding: 16px 12px;
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;

    &--button {
      margin-bottom: 8px;
    }
  }

  &__title {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-3);
    line-height: 150%;
    text-align: left;
    padding-bottom: 8px;
  }

  &__subtitle {
    line-height: 170%;
    font-size: var(--font-size-2);
    text-align: left;
    padding-bottom: 24px;
  }

  .center {
    margin: 44px auto;
  }

  .totalAmount {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;

    &__label {
      color: #363636;
      font-size: var(--font-size-3);
      line-height: 24px;
      font-weight: var(--font-weight-bold);
    }

    &__value {
      color: var(--color-grey-8);
      font-size: var(--font-size-3);
      font-weight: var(--font-weight-medium);
    }
  }

  .drawer-content {
    h3 {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #161616;
      margin-bottom: 24px;
    }

    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 18.75px;
      text-align: center;
      color: var(--color-grey-11);
      margin-bottom: 24px;
    }

    .drawer-buttons {
      display: flex;
      flex-direction: column;

      button {
        border-radius: 8px;
        background-color: var(--color-primary);
        border: 1px solid var(--color-primary);
        color: white;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 0;
        width: 100%;

        &:nth-child(2) {
          margin-top: 16px;
          border-color: transparent;
          background-color: transparent;
          color: var(--color-primary);
        }
      }
    }
  }
}
</style>
